import { CardList } from "../core/styles";
import { CustomApps, CardMenu } from "./UserCards";
import CustomAppCard from "../custom-card/CustomAppCard";
import useProfileStore from "../core/UserProfileStore";
import { getActiveLinks } from "../utils/getActiveLinks";
import { useGetDepartments } from "../dealer-admin/custom-user-links/useLinkQueries";

export function UserCardsList({ 
    userCardList, 
    menuOptions, 
    menuHandler 
}: {
    userCardList: CustomApps;
    menuOptions: CardMenu[];
    menuHandler: Function;
}) {
    const { unifyUserProfile } = useProfileStore();
    const departmentTypes = unifyUserProfile?.departmentTypes;
    const { data: departmentList } = useGetDepartments();
    const activeLinks = getActiveLinks(userCardList, departmentTypes, departmentList);

    return (
        <>
            <CardList>
                {activeLinks.map((app: any) => (
                        <CustomAppCard
                            key={app.appId}
                            id={app.appId || ''}
                            name={app.name || ''}
                            description={app.description || ''}
                            url={app.url || ''}
                            iconText={app.iconText || ''}
                            onCardClick={() => window.open(app.url, "_blank")}
                            onLearnMore={() => menuHandler(menuOptions[0], { ...app })}
                        />
                    ))
                }
            </CardList>
        </>
    )
}